import { BaseQuestionField } from './components/BaseQuestionField';
import { useQuestionField } from './hooks/useQuestionField';

export const QuestionField: React.FC = () => {
	const {
		data: { parent, questions },
	} = useQuestionField();

	if (!parent || !questions.length) return null;

	return (
		<div className="mb-2 flex flex-col gap-2">
			{questions.map((question, idx) => (
				<BaseQuestionField key={question.name} parent={parent} question={question} idx={idx + 1} />
			))}
		</div>
	);
};
